import Joi from 'joi';
import addressSchema, { businessNameSchema } from '../../_ui/_blocks/Form/schemas/addressSchema';
import patientNameSchema, { patientTitleSchema } from '../../_ui/_blocks/Form/schemas/patientNameSchema';

const validationSchema = {
    ...patientTitleSchema,
    ...patientNameSchema,
    address: Joi.object({
        uuid: Joi.string().optional().allow(''),
        ...businessNameSchema,
        ...addressSchema,
    })
        .required()
        .label('Delivery address'),
    post_through_letterbox: Joi.boolean().label('Post through letterbox'),
    default: Joi.boolean().label('Preferred delivery address'),
};

export default validationSchema;
